import { Link } from "react-router-dom";
import { api, errText, mediaUrl } from "../lib/api";
import { Avatar, formatNum } from "./common";
import { Coins, Star, Check, Download, Package } from "lucide-react";
import { toast } from "sonner";

export async function buyProduct(p) {
  await api.post(`/marketplace/products/${p.id}/purchase`);
}

export async function downloadProduct(pid) {
  const { data } = await api.post(`/marketplace/products/${pid}/download-link`);
  const url = mediaUrl(data.url);
  // trigger browser download
  const a = document.createElement("a");
  a.href = url; a.download = data.filename || "download"; document.body.appendChild(a); a.click(); a.remove();
  toast.success("Download started");
}

export function Stars({ value = 0, count }) {
  return (
    <span className="flex items-center gap-0.5 text-gold text-xs">
      <Star size={12} className="fill-gold" />{value ? value.toFixed(1) : "—"}
      {count ? <span className="text-muted-foreground">({count})</span> : null}
    </span>
  );
}

export function ProductCard({ p, onOpen, testid }) {
  const cover = p.preview_images?.[0];
  return (
    <button onClick={() => onOpen(p)} data-testid={testid} className="surface rounded-2xl overflow-hidden card-hover text-left flex flex-col">
      <div className="aspect-[4/3] bg-black/40 relative">
        {cover ? <img src={mediaUrl(cover)} alt="" className="w-full h-full object-cover" loading="lazy" />
          : <div className="w-full h-full flex items-center justify-center text-muted-foreground"><Package size={34} /></div>}
        {p.featured && <span className="absolute top-2 left-2 bg-gold text-black text-[10px] font-bold px-2 py-0.5 rounded-full">FEATURED</span>}
        {p.owned && <span className="absolute top-2 right-2 bg-emerald-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full flex items-center gap-1"><Check size={10} />Owned</span>}
      </div>
      <div className="p-3 flex-1 flex flex-col gap-1">
        <div className="text-sm font-semibold truncate">{p.name}</div>
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
          <Avatar src={p.seller?.avatar_url} name={p.seller?.display_name} size={16} />
          <span className="truncate">@{p.seller?.username}</span>
        </div>
        <div className="flex items-center justify-between mt-1">
          <span className="text-sm font-bold text-gold flex items-center gap-1">{p.price > 0 ? <><Coins size={13} />{formatNum(p.price)}</> : <span className="text-emerald-400">Free</span>}</span>
          {p.rating_count > 0 && <Stars value={p.rating} count={p.rating_count} />}
        </div>
        {p.platforms?.length > 0 && <div className="text-[10px] text-muted-foreground truncate">{p.platforms.join(" · ")}</div>}
      </div>
    </button>
  );
}
